/**
 * MiniCart Drawer — Sifrah
 * Formulario completo: datos personales, despacho, comprobante, facturación
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sifrah_delivery_prefs';
  var API_BASE = window.Shopify.routes.root + 'apps/apolo-ubigeo-calculation';
  var STOREFRONT_GRAPHQL = 'https://sifrah-store.myshopify.com/api/2024-04/graphql.json';
  var STOREFRONT_TOKEN = '857943b7f6cb8bc1dc421e6a129ba03d';
  var EXCLUDED_DEPARTMENTS = [
    'Amazonas', 'Apurímac', 'Huancavelica',
    'Loreto', 'Madre de Dios', 'Pasco', 'Ucayali'
  ];

  var CHECKOUT_BTN_LABEL = 'FINALIZAR PEDIDO';

  var SEL = {
    minicart: '[data-minicart]',
    step: '[data-minicart-step]',
    showFor: '[data-minicart-show]',
    btnNext: '[data-minicart-next]',
    btnBack: '[data-minicart-back]',
    btnCheckout: '[data-minicart-checkout]',
    deliveryTab: '[data-delivery-tab]',
    deliveryPanel: '[data-delivery-panel]',
    /* Shipping ubigeo */
    departamento: '#enova-carrito-block-despacho-shipping__departamento',
    provincia: '#enova-carrito-block-despacho-shipping__provincia',
    distrito: '#enova-carrito-block-despacho-shipping__distrito',
    /* Shipping address */
    direccion: '#mc-despacho-direccion',
    referencia: '#mc-despacho-referencia',
    /* Pickup */
    pickupFilter: '#enova-carrito-block-despacho-recojo__filtro',
    storesContainer: '[data-minicart-stores]',
    /* Shipping methods */
    shippingMethodsWrap: '[data-minicart-shipping-methods]',
    shippingLoading: '[data-minicart-shipping-loading]',
    shippingList: '[data-minicart-shipping-list]',
    shippingRadio: 'input[name="minicart-despacho-tipo"]',
    /* Personal data */
    nombre: '#mc-billing-name',
    apellido: '#mc-billing-lastName',
    email: '#mc-billing-email',
    telefono: '#mc-billing-telefono',
    tipoDocumento: '#mc-billing-documento-type',
    numDocumento: '#mc-billing-documento-number',
    /* Comprobante */
    comprobanteRadio: 'input[name="mc-billing-doc"]',
    facturaFields: '[data-minicart-factura]',
    ruc: '#mc-billing-ruc',
    razonSocial: '#mc-billing-razonsocial',
    /* Message */
    message: '[data-minicart-message]',
    /* Upsell carousel dots */
    upsell: '[data-minicart-upsell]',
    upsellDots: '[data-minicart-upsell-dots]',
    upsellGrid: '[data-grid-slider]'
  };

  /* =========================================================== */
  /* UTILITY                                                      */
  /* =========================================================== */

  function debounce(fn, ms) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  /* =========================================================== */
  /* PREFERENCES (localStorage)                                   */
  /* =========================================================== */

  function readPrefs() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function writePrefs(data) {
    var current = readPrefs();
    var merged = Object.assign(current, data);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    return merged;
  }

  /* =========================================================== */
  /* MINICART CLASS                                               */
  /* =========================================================== */

  class MiniCart {
    constructor(el) {
      this.root = el;
      this.customerId = el.dataset.customerId || null;
      this.ubigeoLoaded = false;
      this.storesData = [];
      this.storesLoaded = false;
      this.currentStep = 1;
      this._checkoutAbortController = null;

      this._bindNavigation();
      this._bindTabs();
      this._bindUbigeo();
      this._bindPickupFilter();
      this._bindFormPersistence();
      this._bindCheckout();
      this._bindCheckoutPageRestore();
      this._bindDrawerOpen();
      this._bindCloseDrawer();
      this._bindViewportZoomFix();
      this._bindUpsellDots();
      this._bindProgressBar();
      try {
        window.sessionStorage.removeItem('skip_upsell_products');
      } catch (e) { }
    }

    /* ---- Evitar zoom al enfocar inputs en móvil sin cambiar font-size (viewport maximum-scale) ---- */
    _bindViewportZoomFix() {
      var self = this;
      var meta = document.querySelector('meta[name="viewport"]');
      if (!meta) return;
      self._viewportOriginal = meta.getAttribute('content') || 'width=device-width, initial-scale=1.0';

      document.addEventListener('theme:cart-drawer:close', function () {
        self._setViewportNoZoom(false);
      });
    }

    _setViewportNoZoom(noZoom) {
      var meta = document.querySelector('meta[name="viewport"]');
      if (!meta || !this._viewportOriginal) return;
      var isMobile = window.innerWidth <= 768;
      if (noZoom && isMobile) {
        var content = this._viewportOriginal;
        if (content.indexOf('maximum-scale') === -1) {
          meta.setAttribute('content', content + ', maximum-scale=1');
        }
      } else {
        meta.setAttribute('content', this._viewportOriginal);
      }
    }

    /* ---- Close drawer on any [data-cart-drawer-close] (step 1 and step 2) ---- */
    _bindCloseDrawer() {
      var self = this;
      this.root.addEventListener('click', function (e) {
        if (!e.target.closest('[data-cart-drawer-close]')) return;
        var drawer = self.root.closest('cart-drawer');
        if (drawer && typeof drawer.closeCartDrawer === 'function') {
          drawer.closeCartDrawer();
        }
      });
    }

    /* ---- Reset to step 1 when a product is added ---- */

    _bindDrawerOpen() {
      var self = this;
      document.addEventListener('theme:product:added', function () {
        self.goToStep(1);
        self._bindUpsellDots();
        self._refreshProgressFromCartJs();
      });
      document.addEventListener('theme:cart:change', function () {
        setTimeout(function () {
          self._updateOrInitUpsellSwiper();
          self._refreshProgressFromCartJs();
        }, 0);
      });
    }

    /* ---- Actualizar Swiper tras cambio de carrito (sync ya ocultó/mostró slides) ---- */
    _updateOrInitUpsellSwiper() {
      var blocks = this.root.querySelectorAll(SEL.upsell);
      blocks.forEach(function (block) {
        if (!block.hasAttribute('data-minicart-upsell-swiper')) return;
        var swiperEl = block.querySelector('.minicart-upsell__swiper');
        var prevEl = block.querySelector('.minicart-upsell__swiper-prev');
        var nextEl = block.querySelector('.minicart-upsell__swiper-next');
        if (!swiperEl || typeof window.Swiper !== 'function') return;
        if (block._minicartSwiper) {
          block._minicartSwiper.update();
          return;
        }
        block._minicartSwiper = new window.Swiper(swiperEl, {
          slidesPerView: 1.5,
          spaceBetween: 12,
          navigation: { nextEl: nextEl, prevEl: prevEl },
          watchSlidesProgress: true,
          resistanceRatio: 0,
          touchReleaseOnEdges: true
        });
      });
    }

    /* ---- Upsell: Swiper (collection) o dots+grid (legacy) ---- */
    _bindUpsellDots() {
      var self = this;
      var blocks = this.root.querySelectorAll(SEL.upsell);
      blocks.forEach(function (block) {
        /* ---- Swiper: no eliminar slides; el theme los oculta/muestra con syncUpsellCollectionVisibility ---- */
        if (block.hasAttribute('data-minicart-upsell-swiper')) {
          var swiperEl = block.querySelector('.minicart-upsell__swiper');
          var prevEl = block.querySelector('.minicart-upsell__swiper-prev');
          var nextEl = block.querySelector('.minicart-upsell__swiper-next');
          if (!swiperEl || typeof window.Swiper !== 'function') return;
          if (block._minicartSwiper) {
            block._minicartSwiper.update();
            return;
          }
          block._minicartSwiper = new window.Swiper(swiperEl, {
            slidesPerView: 1.5,
            spaceBetween: 12,
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl
            },
            watchSlidesProgress: true,
            resistanceRatio: 0,
            touchReleaseOnEdges: true
          });
          return;
        }

        /* ---- Legacy: dots + grid (cart-block-upsell sin Swiper) ---- */
        var grid = block.querySelector(SEL.upsellGrid);
        var dotsContainer = block.querySelector(SEL.upsellDots);
        if (!grid) return;

        var items = Array.from(grid.querySelectorAll('[data-grid-item]')).filter(function (el) {
          return el.style.display !== 'none';
        });
        var count = items.length;
        if (count === 0) return;

        var perPage = 2;
        var numPages = Math.ceil(count / perPage);

        if (dotsContainer && numPages > 1) {
          dotsContainer.innerHTML = '';
          for (var i = 0; i < numPages; i++) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.setAttribute('data-dot', '');
            btn.setAttribute('data-index', i);
            btn.setAttribute('aria-label', 'Página ' + (i + 1));
            if (i === 0) btn.classList.add('is-active');
            dotsContainer.appendChild(btn);
          }
          function setActiveDot(index) {
            dotsContainer.querySelectorAll('[data-dot]').forEach(function (d, i) {
              d.classList.toggle('is-active', i === index);
            });
          }
          dotsContainer.querySelectorAll('[data-dot]').forEach(function (btn, i) {
            btn.addEventListener('click', function () {
              var first = items[i * perPage];
              if (first) grid.scrollTo({ left: first.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
              setActiveDot(i);
            });
          });
        }

        grid.addEventListener('scroll', debounce(function () {
          var gap = 12;
          var itemWidth = items[0] ? items[0].offsetWidth + gap : grid.clientWidth / perPage;
          var index = Math.round(grid.scrollLeft / (itemWidth * perPage));
          index = Math.max(0, Math.min(index, numPages - 1));
          if (dotsContainer) {
            dotsContainer.querySelectorAll('[data-dot]').forEach(function (d, i) {
              d.classList.toggle('is-active', i === index);
            });
          }
        }, 80));

        var gridSlider = block.querySelector('grid-slider');
        if (gridSlider && typeof gridSlider.dispatchEvent === 'function') {
          gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
        }
      });
    }

    /* ---- Step navigation ---- */

    _bindNavigation() {
      this.root.querySelectorAll(SEL.btnNext).forEach(btn => {
        btn.addEventListener('click', () => this.goToStep(2));
      });
      this.root.querySelectorAll(SEL.btnBack).forEach(btn => {
        btn.addEventListener('click', () => this.goToStep(1));
      });
    }

    goToStep(step) {
      if (step === 1) {
        if (this._checkoutAbortController) {
          try { this._checkoutAbortController.abort(); } catch (e) { /* noop */ }
          this._checkoutAbortController = null;
        }
        this._resetCheckoutButtons();
      }
      this.currentStep = step;
      this.root.setAttribute('data-minicart-active', step);
      this._setViewportNoZoom(step === 2);
      if (step === 2) this._onEnterStep2();
    }

    async _onEnterStep2() {
      var prefs = await this._loadPreferences();

      this._prefillFormFields(prefs);

      if (prefs.modalidad === 'recojo-tienda') {
        this._activateTab('pickup');
      } else {
        this._activateTab('shipping');
      }

      if (!this.ubigeoLoaded) {
        await this._initUbigeo(prefs);
      } else {
        this._prefillUbigeo(prefs);
      }

      if (prefs.modalidad === 'recojo-tienda' && !this.storesLoaded) {
        await this._loadStores(null, prefs.last_pickup_store_id);
      }
    }

    /* ---- Delivery tabs ---- */

    _bindTabs() {
      this.root.querySelectorAll(SEL.deliveryTab).forEach(tab => {
        tab.addEventListener('click', () => {
          var mode = tab.dataset.deliveryTab;
          this._activateTab(mode);

          var modalidad = mode === 'pickup' ? 'recojo-tienda' : 'delivery';
          this._savePrefsDebounced({ modalidad: modalidad });

          if (mode === 'pickup' && !this.storesLoaded) {
            var prefs = readPrefs();
            this._loadStores(null, prefs.last_pickup_store_id);
          }
        });
      });
    }

    _activateTab(mode) {
      this.root.querySelectorAll(SEL.deliveryTab).forEach(function (t) {
        t.classList.toggle('minicart-delivery__tab--active', t.dataset.deliveryTab === mode);
      });
      this.root.querySelectorAll(SEL.deliveryPanel).forEach(function (p) {
        p.classList.toggle('minicart-delivery__panel--active', p.dataset.deliveryPanel === mode);
      });
    }

    /* ---- Ubigeo cascade (shipping) ---- */

    _bindUbigeo() {
      var depSel = this.root.querySelector(SEL.departamento);
      var provSel = this.root.querySelector(SEL.provincia);
      var distSel = this.root.querySelector(SEL.distrito);

      if (depSel) {
        depSel.addEventListener('change', async () => {
          this._resetSelect(provSel);
          this._resetSelect(distSel);
          this._hideShippingMethods();

          var depOpt = depSel.options[depSel.selectedIndex];
          if (!depOpt || !depOpt.value) return;

          var depId = depOpt.dataset.id;
          var provinces = await this._fetchUbigeo('provinces', { country: '1', departament: depId });
          this._populateSelect(provSel, provinces);

          this._savePrefsDebounced({ departamento: depOpt.value, provincia: '', distrito: '', ubigeo: '' });
        });
      }

      if (provSel) {
        provSel.addEventListener('change', async () => {
          this._resetSelect(distSel);
          this._hideShippingMethods();

          var depOpt = depSel ? depSel.options[depSel.selectedIndex] : null;
          var provOpt = provSel.options[provSel.selectedIndex];
          if (!depOpt || !depOpt.value || !provOpt || !provOpt.value) return;

          var depId = depOpt.dataset.id;
          var provId = provOpt.dataset.id;
          var districts = await this._fetchUbigeo('distrits', { country: '1', departament: depId, district: provId });
          this._populateSelect(distSel, districts);

          this._savePrefsDebounced({ provincia: provOpt.value, distrito: '', ubigeo: '' });
        });
      }

      if (distSel) {
        distSel.addEventListener('change', () => {
          var opt = distSel.options[distSel.selectedIndex];
          var ubigeo = opt ? (opt.dataset.code || '') : '';
          this._savePrefsDebounced({ distrito: distSel.value, ubigeo: ubigeo });

          if (ubigeo && opt.value && opt.value !== 'Seleccione' && opt.value !== 'Seleccione...') {
            this._loadShippingMethods(ubigeo);
          } else {
            this._hideShippingMethods();
          }
        });
      }
    }

    async _initUbigeo(prefs) {
      var depSel = this.root.querySelector(SEL.departamento);
      if (!depSel) return;

      var departments = await this._fetchUbigeo('departaments', { country: '1' });
      var filtered = departments.filter(function (d) { return !EXCLUDED_DEPARTMENTS.includes(d.name); });
      this._populateSelect(depSel, filtered);
      this.ubigeoLoaded = true;

      if (prefs.departamento) {
        depSel.value = prefs.departamento;
        depSel.dispatchEvent(new Event('change'));
        await this._waitForOptions(this.root.querySelector(SEL.provincia));

        if (prefs.provincia) {
          var provSel = this.root.querySelector(SEL.provincia);
          provSel.value = prefs.provincia;
          provSel.dispatchEvent(new Event('change'));
          await this._waitForOptions(this.root.querySelector(SEL.distrito));

          if (prefs.distrito) {
            var distSel = this.root.querySelector(SEL.distrito);
            distSel.value = prefs.distrito;
            distSel.dispatchEvent(new Event('change'));
          }
        }
      }
    }

    _prefillUbigeo(prefs) {
      if (!prefs.departamento) return;
      var depSel = this.root.querySelector(SEL.departamento);
      if (depSel && depSel.value !== prefs.departamento) {
        depSel.value = prefs.departamento;
      }
    }

    _waitForOptions(selectEl, timeoutMs) {
      timeoutMs = timeoutMs || 3000;
      return new Promise(function (resolve) {
        if (!selectEl) return resolve();
        var start = Date.now();
        var check = function () {
          if (selectEl.options.length > 1 || Date.now() - start > timeoutMs) { resolve(); }
          else { requestAnimationFrame(check); }
        };
        check();
      });
    }

    async _fetchUbigeo(scope, options) {
      try {
        var url = API_BASE;
        if (scope === 'departaments') url += '?scope=departaments&country=' + options.country;
        else if (scope === 'provinces') url += '?scope=provinces&country=' + options.country + '&departament=' + options.departament;
        else if (scope === 'distrits') url += '?scope=distrits&country=' + options.country + '&departament=' + options.departament + '&province=' + options.district;

        var res = await fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
        var data = await res.json();
        return data.filter(function (item) { return !('is_active' in item) || item.is_active; });
      } catch (err) {
        console.error('MiniCart: ubigeo fetch error', err);
        return [];
      }
    }

    _populateSelect(selectEl, items) {
      if (!selectEl) return;
      var html = '<option value="">Seleccione...</option>';
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        html += '<option value="' + item.name + '" data-ubigeo="' + item.code + '" data-code="' + item.code + '" data-id="' + item.id + '">' + item.name + '</option>';
      }
      selectEl.innerHTML = html;
    }

    _resetSelect(selectEl) {
      if (!selectEl) return;
      selectEl.innerHTML = '<option value="">Seleccione</option>';
    }

    /* ---- Shipping methods (carrier service) ---- */

    async _loadShippingMethods(ubigeoCode) {
      var wrap = this.root.querySelector(SEL.shippingMethodsWrap);
      var loading = this.root.querySelector(SEL.shippingLoading);
      var list = this.root.querySelector(SEL.shippingList);
      if (!wrap || !list) return;

      wrap.style.display = 'block';
      if (loading) loading.style.display = 'block';
      list.innerHTML = '';

      try {
        var res = await fetch(API_BASE + '?scope=district-calc-rates&ubigeo=' + ubigeoCode, {
          method: 'GET', headers: { 'Content-Type': 'application/json' }
        });
        var methods = await res.json();
        if (loading) loading.style.display = 'none';

        if (Array.isArray(methods) && methods.length > 0) {
          this._renderShippingMethods(methods);
        } else {
          list.innerHTML = '<p class="minicart-shipping-methods__empty">No hay métodos de envío disponibles para esta zona.</p>';
        }
      } catch (err) {
        console.error('MiniCart: shipping methods error', err);
        if (loading) loading.style.display = 'none';
        list.innerHTML = '<p class="minicart-shipping-methods__empty">Error al obtener métodos de envío.</p>';
      }
    }

    _getFreeShippingLimit() {
      return parseFloat(this.root.dataset.freeShippingLimit) || 0;
    }

    _getCartTotalSoles(totalCentsOverride) {
      if (typeof totalCentsOverride === 'number') {
        return totalCentsOverride / 100;
      }
      var cartTotalEl = this.root.querySelector('[data-cart-total]');
      var cartTotalCents = cartTotalEl ? parseInt(cartTotalEl.dataset.cartTotal, 10) || 0 : 0;
      return cartTotalCents / 100;
    }

    _isFreeShipping(totalCentsOverride) {
      var limit = this._getFreeShippingLimit();
      if (!limit) return false;
      return this._getCartTotalSoles(totalCentsOverride) >= limit;
    }

    _formatShippingCost(method, totalCentsOverride) {
      if (this._isFreeShipping(totalCentsOverride)) {
        return '<span class="minicart-shipping-method__cost minicart-shipping-method__cost--free">Gratis</span>';
      }
      return '<span class="minicart-shipping-method__cost">S/ ' + method.shipping_price + '</span>';
    }

    _renderShippingMethods(methods, totalCentsOverride) {
      var list = this.root.querySelector(SEL.shippingList);
      if (!list) return;
      this._lastShippingMethods = methods;
      var html = '';
      for (var i = 0; i < methods.length; i++) {
        var m = methods[i];
        var checked = i === 0 ? 'checked' : '';
        html += '<label class="minicart-shipping-method" for="minicart-shipping-' + m.shipping_method_code + '">'
          + '<input type="radio" name="minicart-despacho-tipo" id="minicart-shipping-' + m.shipping_method_code + '" value="' + m.shipping_method_code + '" ' + checked + ' />'
          + '<div class="minicart-shipping-method__info">'
          + '<p class="minicart-shipping-method__name">' + m.shipping_method_name + ' ' + this._formatShippingCost(m, totalCentsOverride) + '</p>'
          + (m.description ? '<p class="minicart-shipping-method__desc">' + m.description + '</p>' : '')
          + '</div></label>';
      }
      list.innerHTML = html;
    }

    _refreshShippingCosts(totalCentsOverride) {
      if (!this._lastShippingMethods || !this._lastShippingMethods.length) return;
      this._renderShippingMethods(this._lastShippingMethods, totalCentsOverride);
    }

    _hideShippingMethods() {
      var wrap = this.root.querySelector(SEL.shippingMethodsWrap);
      if (wrap) wrap.style.display = 'none';
    }

    /* ---- Pickup stores ---- */

    _bindPickupFilter() {
      var filterSel = this.root.querySelector(SEL.pickupFilter);
      if (filterSel) {
        filterSel.addEventListener('change', () => {
          var prefs = readPrefs();
          this._loadStores(filterSel.value, prefs.last_pickup_store_id);
        });
      }
    }

    async _loadStores(filterZona, savedStoreId) {
      var container = this.root.querySelector(SEL.storesContainer);
      if (!container) return;
      container.innerHTML = '<p class="minicart-delivery__stores-loading">Cargando tiendas...</p>';

      try {
        var res = await fetch(API_BASE + '?scope=shop-addresses', { method: 'GET', headers: { 'Content-Type': 'application/json' } });
        var data = await res.json();
        var stores = data.items || [];
        if (filterZona) stores = stores.filter(function (s) { return s.department === filterZona; });
        this.storesData = stores;
        this.storesLoaded = true;
        this._renderStores(stores, savedStoreId);
      } catch (err) {
        console.error('MiniCart: stores fetch error', err);
        container.innerHTML = '<p class="minicart-delivery__stores-loading">Error al cargar tiendas.</p>';
      }
    }

    _renderStores(stores, savedStoreId) {
      var container = this.root.querySelector(SEL.storesContainer);
      if (!container) return;
      if (stores.length === 0) {
        container.innerHTML = '<p class="minicart-delivery__stores-loading">No se encontraron tiendas.</p>';
        return;
      }
      var ordered = stores.slice();
      if (savedStoreId) {
        var idx = ordered.findIndex(function (s) { return String(s.id) === String(savedStoreId); });
        if (idx > 0) { var saved = ordered.splice(idx, 1); ordered.unshift(saved[0]); }
      }
      var html = '';
      for (var i = 0; i < ordered.length; i++) {
        var store = ordered[i];
        var isChecked = savedStoreId && String(store.id) === String(savedStoreId) ? 'checked' : '';
        html += '<label class="minicart-store" for="minicart-store-' + store.id + '">'
          + '<input type="radio" name="minicart-store" id="minicart-store-' + store.id + '" value="' + store.id + '"'
          + ' data-departamento="' + store.department + '" data-provincia="' + store.province + '"'
          + ' data-distrito="' + (store.distrit_name || '') + '" data-ubigeo="' + (store.ubigeo || '') + '"'
          + ' data-address="' + (store.address || '') + '" data-name="' + (store.name || '') + '"'
          + ' ' + isChecked + ' />'
          + '<div class="minicart-store__info"><p class="minicart-store__name">' + store.name + '</p>'
          + '<p class="minicart-store__address">' + store.address + '</p></div></label>';
      }
      container.innerHTML = html;
      container.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', () => {
          this._savePrefsDebounced({ last_pickup_store_id: radio.value });
        });
      });
    }

    /* ---- Form field persistence (solo dirección y referencia) ---- */

    _bindFormPersistence() {
      var self = this;
      var TEXT_FIELDS = [
        { sel: SEL.direccion, key: 'f_direccion' },
        { sel: SEL.referencia, key: 'f_referencia' }
      ];
      TEXT_FIELDS.forEach(function (f) {
        var el = self.root.querySelector(f.sel);
        if (!el) return;
        el.addEventListener('input', debounce(function () {
          var obj = {}; obj[f.key] = el.value;
          writePrefs(obj);
        }, 600));
      });
    }

    _prefillFormFields(prefs) {
      var self = this;
      var TEXT_MAP = [
        { sel: SEL.direccion, key: 'f_direccion' },
        { sel: SEL.referencia, key: 'f_referencia' }
      ];
      TEXT_MAP.forEach(function (f) {
        if (prefs[f.key]) {
          var el = self.root.querySelector(f.sel);
          if (el) el.value = prefs[f.key];
        }
      });
    }

    /* ---- Preferences save (debounced) ---- */

    _savePrefsDebounced = debounce(function (data) {
      writePrefs(data);
      this._saveMetafields(data);
    }, 800);

    /* ---- Checkout flow ---- */

    _bindCheckout() {
      this.root.querySelectorAll(SEL.btnCheckout).forEach(btn => {
        btn.addEventListener('click', () => this._handleCheckout(btn));
      });
    }

    _bindCheckoutPageRestore() {
      var self = this;
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        if (self._checkoutAbortController) {
          try { self._checkoutAbortController.abort(); } catch (err) { /* noop */ }
          self._checkoutAbortController = null;
        }
        self._resetCheckoutButtons();
      });
    }

    _resetCheckoutButtons() {
      this.root.querySelectorAll(SEL.btnCheckout).forEach(function (btn) {
        btn.setAttribute('aria-busy', 'false');
        btn.textContent = CHECKOUT_BTN_LABEL;
      });
    }

    async _handleCheckout(btn) {
      var msgEl = this.root.querySelector(SEL.message);
      if (msgEl) { msgEl.style.display = 'none'; msgEl.textContent = ''; }

      this._clearFieldErrors();

      var activeTab = this.root.querySelector('.minicart-delivery__tab--active');
      var modalidad = activeTab && activeTab.dataset.deliveryTab === 'pickup' ? 'recojo-tienda' : 'delivery';
      var attributes = this._buildAttributes(modalidad);
      var validation = this._validateAttributes(attributes, modalidad);

      if (!validation.valid) {
        if (msgEl) {
          msgEl.textContent = validation.message;
          msgEl.style.display = 'block';
        }
        return;
      }

      if (btn.getAttribute('aria-busy') === 'true') return;

      var ac = new AbortController();
      this._checkoutAbortController = ac;
      var signal = ac.signal;

      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Procesando...';

      var prefs = {
        modalidad: modalidad,
        departamento: attributes['departamento'] || '',
        provincia: attributes['provincia'] || '',
        distrito: attributes['distrito'] || '',
        ubigeo: attributes['ubigeo'] || ''
      };

      if (modalidad === 'recojo-tienda') {
        var checkedStore = this.root.querySelector('input[name="minicart-store"]:checked');
        if (checkedStore) prefs.last_pickup_store_id = checkedStore.value;
      }

      var val = function (sel) { var el = document.querySelector(sel); return el ? el.value.trim() : ''; };
      prefs.f_direccion = val(SEL.direccion);
      prefs.f_referencia = val(SEL.referencia);

      writePrefs(prefs);
      this._saveMetafields(prefs);

      try {
        var updateRes = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes }),
          signal: signal
        });
        if (!updateRes.ok) throw new Error('Error al actualizar carrito');

        console.log('MiniCart: attributes for checkout', attributes);
        var checkout = await this._createStorefrontCheckout(attributes, modalidad, signal);

        if (checkout && checkout.id) {
          var redirectUrl = checkout.webUrl || null;
          if (!redirectUrl) {
            var cartGid = String(checkout.id);
            var cartToken = cartGid.split('gid://shopify/Cart/')[1];
            if (cartToken) {
              redirectUrl = window.location.origin + '/cart/c/' + cartToken + '&channel=buy_button&_fd=0';
            }
          }
          if (redirectUrl) {
            this._checkoutAbortController = null;
            window.location.href = redirectUrl;
          } else {
            throw new Error('No se pudo obtener URL de checkout');
          }
        } else {
          throw new Error('No se pudo crear el checkout');
        }
      } catch (err) {
        this._checkoutAbortController = null;
        if (err && err.name === 'AbortError') {
          this._resetCheckoutButtons();
          return;
        }
        function toPlainError(e) {
          if (!e) return { message: 'Unknown error' };
          var plain = { message: e.message, name: e.name, when: new Date().toISOString() };
          if (e.errors) plain.errors = e.errors;
          if (e.stack) plain.stack = e.stack;
          if (e.body) plain.body = e.body;
          if (e.statusCode) plain.statusCode = e.statusCode;
          if (e.description) plain.description = e.description;
          if (e.reason) plain.reason = e.reason;
          if (!plain.message && typeof e.toString === 'function') plain.message = e.toString();
          if (!plain.message) plain.message = JSON.stringify(e);
          return plain;
        }
        var errDetail = toPlainError(err);
        try { sessionStorage.setItem('minicart_last_error', JSON.stringify(errDetail, null, 2)); } catch (e) {}
        console.error('MiniCart: checkout error', errDetail);
        try {
          var cartRes = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
          var cartData = await cartRes.json();
          if (cartData.token) {
            window.location.href = window.location.origin + '/checkouts/cn/' + cartData.token;
            return;
          }
        } catch (fallbackErr) {
          console.error('MiniCart: fallback checkout error', fallbackErr);
        }
        btn.setAttribute('aria-busy', 'false');
        btn.textContent = CHECKOUT_BTN_LABEL;
        if (msgEl) {
          msgEl.textContent = 'Error: ' + (errDetail.message || 'Ver consola (F12)');
          msgEl.style.display = 'block';
          msgEl.setAttribute('title', 'Detalle en sessionStorage.minicart_last_error (misma pestaña, misma URL)');
        }
      }
    }

    /* ---- Storefront Cart API (oficial; Checkout API está deprecado) ---- */

    /**
     * Crea un carrito con la Cart API, prellena la dirección con cartBuyerIdentityUpdate
     * y devuelve { id, webUrl } para redirigir a checkout.
     * Ref: https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/cart/migrate-to-cart-api
     */
    async _createStorefrontCheckout(attributes, modalidad, signal) {
      var cartRes = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET', signal: signal });
      var cartData = await cartRes.json();
      var shippingAddress = this._buildCheckoutAddress(attributes);

      if (!shippingAddress.address1 || !shippingAddress.city || !shippingAddress.zip) {
        console.warn('MiniCart: address incomplete', { attributes: attributes, built: shippingAddress });
      }
      console.log('MiniCart: shippingAddress built', JSON.stringify(shippingAddress));

      var lines = cartData.items.map(function (item) {
        return {
          merchandiseId: 'gid://shopify/ProductVariant/' + item.variant_id,
          quantity: item.quantity,
          attributes: [
            { key: 'tipo de despacho', value: modalidad },
            { key: 'shipping method', value: attributes['tipo de envio'] || '' },
            { key: 'ubigeo', value: String(attributes['ubigeo'] || '') }
          ]
        };
      });

      var cartAttrs = [];
      for (var key in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, key)) {
          cartAttrs.push({ key: key, value: attributes[key] });
        }
      }

      var emailForApi = (attributes['email'] || '').trim();
      if (!emailForApi || emailForApi === 'guest@checkout.local') emailForApi = null;

      var cartCreateMutation = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart { id checkoutUrl }
            userErrors { field message }
          }
        }
      `;
      var cartCreateVars = {
        input: {
          lines: lines,
          buyerIdentity: { email: emailForApi, countryCode: 'PE' },
          attributes: cartAttrs
        }
      };

      var res = await fetch(STOREFRONT_GRAPHQL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: cartCreateMutation, variables: cartCreateVars }),
        signal: signal
      });
      if (!res.ok) throw new Error('Cart API: ' + res.status);
      var data = await res.json();
      if (data.errors && data.errors.length) throw new Error(data.errors[0].message);
      var payload = data.data && data.data.cartCreate;
      if (!payload || !payload.cart) {
        var errMsg = (payload && payload.userErrors && payload.userErrors.length) ? payload.userErrors[0].message : 'No se pudo crear el carrito';
        throw new Error(errMsg);
      }
      if (payload.userErrors && payload.userErrors.length) {
        try { sessionStorage.setItem('minicart_last_error', JSON.stringify({ when: 'cartCreate', userErrors: payload.userErrors }, null, 2)); } catch (e) {}
        throw new Error(payload.userErrors[0].message);
      }

      var cart = payload.cart;
      var cartId = cart.id;
      var checkoutUrl = cart.checkoutUrl;

      var updateMutation = `
        mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
          cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
            cart { id checkoutUrl }
            userErrors { field message }
          }
        }
      `;
      var updateVars = {
        cartId: cartId,
        buyerIdentity: {
          email: emailForApi,
          countryCode: 'PE',
          deliveryAddressPreferences: [{
            deliveryAddress: {
              address1: shippingAddress.address1,
              address2: shippingAddress.address2 || '',
              city: shippingAddress.city || '',
              company: shippingAddress.company || '',
              country: shippingAddress.country,
              firstName: shippingAddress.firstName || '',
              lastName: shippingAddress.lastName || '',
              phone: shippingAddress.phone || '',
              province: shippingAddress.province || '',
              zip: shippingAddress.zip || ''
            }
          }]
        }
      };

      var res2 = await fetch(STOREFRONT_GRAPHQL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: updateMutation, variables: updateVars }),
        signal: signal
      });
      if (!res2.ok) throw new Error('Cart API update: ' + res2.status);
      var data2 = await res2.json();
      if (data2.errors && data2.errors.length) throw new Error(data2.errors[0].message);
      var updatePayload = data2.data && data2.data.cartBuyerIdentityUpdate;
      if (updatePayload && updatePayload.cart && updatePayload.cart.checkoutUrl) {
        checkoutUrl = updatePayload.cart.checkoutUrl;
      }
      if (updatePayload && updatePayload.userErrors && updatePayload.userErrors.length) {
        console.warn('MiniCart: cartBuyerIdentityUpdate userErrors', updatePayload.userErrors);
      }

      return { id: cartId, webUrl: checkoutUrl };
    }

    async _getCartLineItems(modalidad, attributes) {
      var res = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
      var cart = await res.json();

      function utf8ToB64(str) { return window.btoa(unescape(encodeURIComponent(str))); }

      var shippingMethod = attributes['tipo de envio'] || '';
      var ubigeo = String(attributes['ubigeo'] || '');

      return cart.items.map(function (item) {
        return {
          variantId: utf8ToB64('gid://shopify/ProductVariant/' + item.variant_id),
          quantity: item.quantity,
          attributes: [
            { key: 'tipo de despacho', value: modalidad },
            { key: 'shipping method', value: shippingMethod },
            { key: 'ubigeo', value: ubigeo }
          ]
        };
      });
    }

    _buildCheckoutAddress(attrs) {
      function getProvinceCode(province) {
        switch (province) {
          case 'Lima': case 'LIMA': return 'PE-LIM';
          default: return province;
        }
      }
      var address1 = (attrs['direccion'] || '').trim() || '';
      var ref = (attrs['referencia'] || '').trim();
      if (ref === '-') ref = '';
      var address2 = ref;
      var city = (attrs['distrito'] || attrs['provincia'] || '').trim() || '';
      var zip = (attrs['ubigeo'] || attrs['distrito'] || '').trim() || '';
      return {
        address1: address1,
        address2: address2,
        firstName: '',
        lastName: '',
        company: '',
        phone: '',
        country: 'Peru',
        province: getProvinceCode(attrs['departamento']) || 'PE-LIM',
        city: city,
        zip: zip
      };
    }

    /* ---- Build attributes (solo tipo de entrega + campos respectivos) ---- */

    _buildAttributes(modalidad) {
      var root = this.root;
      var val = function (sel) {
        var el = root.querySelector(sel);
        return el ? String(el.value || '').trim() : '';
      };
      var selText = function (sel) {
        var el = root.querySelector(sel);
        if (!el) return '';
        var opt = el.options[el.selectedIndex];
        return opt ? String(opt.text || '').trim() : '';
      };
      var selCode = function (sel) {
        var el = root.querySelector(sel);
        if (!el) return '';
        var opt = el.options[el.selectedIndex];
        if (!opt) return '';
        return (opt.dataset && (opt.dataset.code || opt.dataset.ubigeo)) || opt.getAttribute('data-code') || opt.getAttribute('data-ubigeo') || '';
      };

      var customerEmail = (root.dataset.customerEmail || '').trim();
      var attrs = {
        'pais': 'Peru',
        'Modalidad despacho': modalidad,
        'email': customerEmail || 'guest@checkout.local'
      };

      /* Delivery */
      if (modalidad === 'delivery') {
        attrs['departamento'] = selText(SEL.departamento);
        attrs['provincia'] = selText(SEL.provincia);
        attrs['distrito'] = selText(SEL.distrito);
        attrs['ubigeo'] = selCode(SEL.distrito);
        attrs['direccion'] = val(SEL.direccion);
        attrs['referencia'] = val(SEL.referencia);

        var shippingMethod = this.root.querySelector(SEL.shippingRadio + ':checked');
        attrs['tipo de envio'] = shippingMethod ? shippingMethod.value : '';
      }

      /* Recojo en tienda */
      if (modalidad === 'recojo-tienda') {
        var store = this.root.querySelector('input[name="minicart-store"]:checked');
        if (store) {
          attrs['departamento'] = store.dataset.departamento || '';
          attrs['provincia'] = store.dataset.provincia || '';
          attrs['distrito'] = store.dataset.distrito || '';
          attrs['ubigeo'] = store.dataset.ubigeo || '';
          attrs['direccion'] = (store.dataset.name || '') + (store.dataset.address ? ': ' + store.dataset.address : '');
          attrs['referencia'] = '';
          attrs['tienda recojo'] = store.dataset.name || '';
        }
      }

      return attrs;
    }

    /* ---- Validation (solo tipo de entrega + campos respectivos) ---- */

    _validateAttributes(attrs, modalidad) {
      if (!attrs['departamento'] || !attrs['provincia'] || !attrs['distrito'] || !attrs['ubigeo']) {
        return { valid: false, message: 'Completa los campos de ubicación.' };
      }

      if (modalidad === 'delivery') {
        if (!attrs['direccion']) return { valid: false, message: 'Ingresa tu dirección de envío.' };
        if (!attrs['tipo de envio']) return { valid: false, message: 'Selecciona un método de envío.' };
      }

      if (modalidad === 'recojo-tienda' && !attrs['tienda recojo']) {
        return { valid: false, message: 'Selecciona una tienda de recojo.' };
      }

      return { valid: true, message: '' };
    }

    _clearFieldErrors() {
      this.root.querySelectorAll('.minicart-form-field--error').forEach(function (el) {
        el.classList.remove('minicart-form-field--error');
      });
    }

    /* ---- Metafields (Fase 2) ---- */

    async _loadPreferences() {
      var metafieldPrefs = {};
      if (this.customerId) {
        try { metafieldPrefs = await this._fetchMetafields(); }
        catch (e) { metafieldPrefs = {}; }
      }

      var localPrefs = readPrefs();

      if (Object.keys(metafieldPrefs).length > 0) {
        var merged = Object.assign({}, localPrefs, metafieldPrefs);
        writePrefs(merged);
        return merged;
      }

      return localPrefs;
    }

    async _fetchMetafields() {
      if (!this.customerId) return {};
      try {
        var res = await fetch(API_BASE + '?scope=customer-prefs&customer_id=' + this.customerId, {
          method: 'GET', headers: { 'Content-Type': 'application/json' }
        });
        if (!res.ok) return {};
        var data = await res.json();
        if (!data || typeof data !== 'object') return {};

        var prefs = Object.assign({}, data);

        if (data.modalidad_despacho && !data.modalidad) {
          prefs.modalidad = data.modalidad_despacho;
        }

        var hasAnyData = Object.keys(prefs).some(function (k) {
          return k !== 'customer_id' && prefs[k] !== '' && prefs[k] != null;
        });

        return hasAnyData ? prefs : {};
      } catch (err) {
        console.error('MiniCart: metafields read error', err);
        return {};
      }
    }

    async _saveMetafields(data) {
      if (!this.customerId) return;
      try {
        var allPrefs = readPrefs();

        if (data && typeof data === 'object') {
          Object.assign(allPrefs, data);
        }

        if (allPrefs.modalidad && !allPrefs.modalidad_despacho) {
          allPrefs.modalidad_despacho = allPrefs.modalidad;
        }

        allPrefs.customer_id = this.customerId;

        await fetch(API_BASE + '?scope=customer-prefs', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(allPrefs)
        });
      } catch (err) {
        console.error('MiniCart: metafields save error', err);
      }
    }

    /* ---- Progress bar ---- */

    _bindProgressBar() {
      var wrap = this.root.querySelector(PROGRESS_SEL.wrap);
      if (!wrap) return;

      this._progressEl = wrap;
      this._progressGoals = this._parseGoals(wrap);
      this._giftThreshold = parseFloat(wrap.dataset.giftThreshold) || 0;
      this._giftVariantId = wrap.dataset.giftProductId || null;
      this._giftAdding = false;

      this._updateProgressBar();
    }

    _parseGoals(wrap) {
      var goals = [];
      for (var i = 1; i <= 4; i++) {
        var type = wrap.dataset['goal' + i + 'Type'];
        var threshold = parseFloat(wrap.dataset['goal' + i + 'Threshold']) || 0;
        var label = wrap.dataset['goal' + i + 'Label'] || '';
        if (type === 'none' || threshold === 0) continue;
        goals.push({ index: i, type: type, threshold: threshold, label: label });
      }
      return goals;
    }

    _refreshProgressFromCartJs() {
      if (!this._progressEl) return;
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self._updateProgressBar(cart.item_count, cart.total_price);
        })
        .catch(function () {});
    }

    _updateProgressBar(itemCountOverride, totalCentsOverride) {
      if (!this._progressEl) return;

      var wrap = this._progressEl;
      var goals = this._progressGoals;
      if (!goals.length) return;

      var itemCount, totalCents;
      if (typeof itemCountOverride === 'number') {
        itemCount = itemCountOverride;
        totalCents = totalCentsOverride || 0;
      } else {
        var cartTotalEl = this.root.querySelector('[data-cart-total]');
        totalCents = cartTotalEl ? parseInt(cartTotalEl.dataset.cartTotal, 10) || 0 : 0;
        var cartCountEl = document.querySelector('[data-cart-count]');
        itemCount = cartCountEl ? parseInt(cartCountEl.dataset.cartCount, 10) || 0 : 0;
      }

      var totalSoles = totalCents / 100;
      var allMet = true;
      var nextGoalLabel = '';
      var nextGoalRemaining = 0;
      var metCount = 0;

      goals.forEach(function (g) {
        var met = false;
        if (g.type === 'units') {
          met = itemCount >= g.threshold;
        } else {
          met = totalSoles >= g.threshold;
        }
        g.met = met;
        if (met) metCount++;

        if (!met && allMet) {
          allMet = false;
          nextGoalLabel = g.label;
          if (g.type === 'units') {
            nextGoalRemaining = g.threshold - itemCount;
          } else {
            nextGoalRemaining = g.threshold - totalSoles;
          }
        }
      });

      var hasGift = this._giftThreshold > 0 && this._giftVariantId;
      var giftUnlocked = false;
      if (hasGift) {
        giftUnlocked = totalSoles >= this._giftThreshold;
        if (!giftUnlocked && allMet) {
          allMet = false;
          nextGoalLabel = 'el regalo';
          nextGoalRemaining = this._giftThreshold - totalSoles;
        }
      }

      var totalSegments = goals.length;
      var milestonePositions = [];
      goals.forEach(function (g, idx) {
        milestonePositions.push(((idx + 1) / totalSegments) * 100);
      });

      var progressValue = 0;
      if (goals.length > 0) {
        var firstUnmetIdx = -1;
        for (var gi = 0; gi < goals.length; gi++) {
          if (!goals[gi].met) { firstUnmetIdx = gi; break; }
        }

        if (firstUnmetIdx === -1) {
          progressValue = 100;
        } else {
          var prevPos = firstUnmetIdx > 0 ? milestonePositions[firstUnmetIdx - 1] : 0;
          var curPos = milestonePositions[firstUnmetIdx];
          var g = goals[firstUnmetIdx];
          var segmentProgress = 0;

          if (g.type === 'units') {
            var prevThreshold = firstUnmetIdx > 0 ? goals[firstUnmetIdx - 1].threshold : 0;
            if (goals[firstUnmetIdx - 1] && goals[firstUnmetIdx - 1].type !== 'units') prevThreshold = 0;
            segmentProgress = Math.min(itemCount / g.threshold, 1);
          } else {
            segmentProgress = Math.min(totalSoles / g.threshold, 1);
          }

          progressValue = prevPos + segmentProgress * (curPos - prevPos);
        }
        progressValue = Math.min(progressValue, 100);
      }

      var maxThreshold = 0;
      goals.forEach(function (g) {
        if (g.threshold > maxThreshold) maxThreshold = g.threshold;
      });
      if (hasGift && this._giftThreshold > maxThreshold) maxThreshold = this._giftThreshold;

      var fill = wrap.querySelector(PROGRESS_SEL.fill);
      if (fill) fill.style.width = progressValue + '%';

      var milestoneEls = wrap.querySelectorAll('[data-mc-milestone]');
      milestoneEls.forEach(function (ms) {
        var msIndex = parseInt(ms.dataset.mcMilestone, 10);
        var goalIdx = -1;
        for (var mi = 0; mi < goals.length; mi++) {
          if (goals[mi].index === msIndex) { goalIdx = mi; break; }
        }
        if (goalIdx === -1) return;

        var msPercent = milestonePositions[goalIdx] || 0;
        ms.style.left = msPercent + '%';

        if (goals[goalIdx].met) {
          ms.classList.add('mc-progress__milestone--met');
        } else {
          ms.classList.remove('mc-progress__milestone--met');
        }
      });

      var messageEl = wrap.querySelector(PROGRESS_SEL.message);
      if (messageEl) {
        if (allMet) {
          messageEl.innerHTML = '¡Felicidades! Desbloqueaste todos los beneficios 🎉';
        } else {
          var isUnits = false;
          goals.forEach(function (g) {
            if (!g.met && !isUnits) {
              isUnits = g.type === 'units';
            }
          });
          if (hasGift && goals.every(function (g) { return g.met; })) {
            isUnits = false;
          }
          var remainText = isUnits
            ? nextGoalRemaining + (nextGoalRemaining === 1 ? ' unidad' : ' unidades')
            : 'S/ ' + nextGoalRemaining.toFixed(2);
          var unlockShort = nextGoalLabel || '';
          if (unlockShort) {
            var desdeM = unlockShort.match(/\s+desde\s/i);
            if (desdeM) unlockShort = unlockShort.slice(0, desdeM.index).trim();
          }
          var unlockEsc = String(unlockShort)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
          var teVerb = 'faltan';
          if (isUnits) {
            teVerb = nextGoalRemaining === 1 ? 'falta' : 'faltan';
          }
          messageEl.innerHTML =
            'Te ' +
            teVerb +
            ' <strong>' +
            remainText +
            '</strong> para desbloquear <strong>' +
            unlockEsc +
            '</strong>';
        }
      }

      var goalEls = wrap.querySelectorAll(PROGRESS_SEL.goals);
      var self = this;
      goals.forEach(function (g) {
        goalEls.forEach(function (el) {
          if (parseInt(el.dataset.mcGoal, 10) !== g.index) return;
          var labelEl = el.querySelector('.mc-progress__goal-label');
          var defLabel = labelEl && labelEl.getAttribute('data-mc-goal-label-default');
          var metLabel = labelEl && labelEl.getAttribute('data-mc-goal-label-met');
          if (g.met) {
            if (!el.classList.contains('mc-progress__goal--met')) {
              el.classList.add('mc-progress__goal--met');
              var checkSpan = el.querySelector('.mc-progress__goal-check');
              if (checkSpan) {
                checkSpan.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
              }
            }
            if (labelEl && metLabel) labelEl.textContent = metLabel;
            else if (labelEl && defLabel) labelEl.textContent = defLabel;
          } else {
            el.classList.remove('mc-progress__goal--met');
            var checkSpan = el.querySelector('.mc-progress__goal-check');
            if (checkSpan) {
              checkSpan.innerHTML = '<span class="mc-progress__goal-dot"></span>';
            }
            if (labelEl && defLabel) labelEl.textContent = defLabel;
          }
        });
      });

      var giftBadge = wrap.querySelector(PROGRESS_SEL.giftBadge);
      if (giftBadge) {
        if (giftUnlocked) {
          if (!giftBadge.classList.contains('is-unlocked')) {
            giftBadge.classList.add('is-unlocked');
          }
        } else {
          giftBadge.classList.remove('is-unlocked');
        }
      }

      if (hasGift) {
        this._handleGiftProduct(giftUnlocked);
      }

      this._refreshShippingCosts(totalCents);
    }

    _handleGiftProduct(shouldBeInCart) {
      if (this._giftAdding) return;
      var variantId = this._giftVariantId;
      if (!variantId) return;

      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cartData) {
          var giftInCart = cartData.items.some(function (item) {
            return String(item.variant_id) === String(variantId) && item.properties && item.properties._gift === 'true';
          });

          if (shouldBeInCart && !giftInCart) {
            self._giftAdding = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({
                items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _gift: 'true' } }]
              })
            })
            .then(function () {
              self._giftAdding = false;
              self._refreshCart();
            })
            .catch(function () { self._giftAdding = false; });
          } else if (!shouldBeInCart && giftInCart) {
            var giftItem = cartData.items.find(function (item) {
              return String(item.variant_id) === String(variantId) && item.properties && item.properties._gift === 'true';
            });
            if (giftItem) {
              self._giftAdding = true;
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ line: cartData.items.indexOf(giftItem) + 1, quantity: 0 })
              })
              .then(function () {
                self._giftAdding = false;
                self._refreshCart();
              })
              .catch(function () { self._giftAdding = false; });
            }
          }
        })
        .catch(function (err) {
          console.warn('MiniCart: gift product check error', err);
        });
    }

    _refreshCart() {
      var cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && typeof cartItemsEl.getCart === 'function') {
        cartItemsEl.getCart();
      }
    }
  }

  /* =========================================================== */
  /* PROGRESS BAR                                                 */
  /* =========================================================== */

  var PROGRESS_SEL = {
    wrap: '[data-mc-progress]',
    message: '[data-mc-progress-message]',
    remaining: '[data-mc-progress-remaining]',
    fill: '[data-mc-progress-fill]',
    icon: '[data-mc-progress-icon]',
    goals: '[data-mc-goal]',
    giftBadge: '[data-mc-gift-badge]',
    apiProgress: '[data-api-cart-progress]'
  };

  /* =========================================================== */
  /* INIT                                                         */
  /* =========================================================== */

  function init() {
    var el = document.querySelector(SEL.minicart);
    if (el) window.sifrahMiniCart = new MiniCart(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
